import React from 'react';
import { Avatar, SvgIcon, colors } from '@material-ui/core';
import IconRenderer from '../IconRenderer';

const IconAvatar = ({
  backgroundColor,
  iconName
}: {
  backgroundColor?: string,
  iconName: string,
}) => (
  <Avatar style={{ backgroundColor: backgroundColor || colors.blue['500'] }}>
    <SvgIcon fontSize="small">
      <IconRenderer iconName={iconName} />
    </SvgIcon>
  </Avatar>
);

export default IconAvatar;
